import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id"]

import type { SectionProps } from "./SectionProps";
import ScrollAnimation from "@/views/blocks/shared/section/animations/ScrollAnimation.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Section',
  props: {
    id: {},
    backgroundColor: {},
    scrollAnimationType: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ScrollAnimation, { type: _ctx.scrollAnimationType }, {
    default: _withCtx(() => [
      _createElementVNode("section", {
        id: _ctx.id,
        style: _normalizeStyle({ backgroundColor: _ctx.backgroundColor })
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 12, _hoisted_1)
    ]),
    _: 3
  }, 8, ["type"]))
}
}

})